(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["printess-cart"] && !Shopify.designMode) return;
  try {
    (() => {
    const rootSelector = '[data-printess-cart-item], [data-printess-cart-addon]';

    document.querySelectorAll('style[data-printess-cart-styles]').forEach((style, index) => {
      if (index > 0) style.remove();
    });

    const closeDialog = (dialog) => {
      if (!dialog) return;
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    };

    const openDialog = (wrapper) => {
      const dialog = wrapper.querySelector('[data-printess-cart-lightbox]');
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    };

    const replaceProductImage = (wrapper) => {
      if (wrapper.dataset.printessReplaceProductImage !== 'true') return;

      const thumbnail = wrapper.dataset.printessThumbnail;
      const cartItemSelector = wrapper.dataset.printessCartItemSelector || '.cart-item';
      const productImageSelector = wrapper.dataset.printessProductImageSelector || '.cart-item__image img';
      if (!thumbnail || !thumbnail.startsWith('https://')) return;

      let cartItem;
      let productImage;
      try {
        cartItem = wrapper.closest(cartItemSelector);
        productImage = cartItem ? cartItem.querySelector(productImageSelector) : null;
      } catch {
        return;
      }

      if (!productImage || productImage.closest(rootSelector)) return;

      productImage.src = thumbnail;
      productImage.removeAttribute('srcset');
      productImage.removeAttribute('sizes');
      productImage.removeAttribute('data-src');
      productImage.removeAttribute('data-srcset');
      productImage.alt = wrapper.dataset.printessPreviewAlt || productImage.alt;
      productImage.style.setProperty('object-fit', 'contain');
      productImage.dataset.printessThumbnailApplied = 'true';

      const picture = productImage.closest('picture');
      if (picture) {
        picture.querySelectorAll('source').forEach((source) => {
          source.removeAttribute('srcset');
          source.removeAttribute('data-srcset');
        });
      }

      const imageLink = productImage.closest('a');
      if (imageLink && imageLink.dataset.printessPreviewBound !== 'true') {
        imageLink.href = thumbnail;
        imageLink.removeAttribute('target');
        imageLink.dataset.printessPreviewBound = 'true';
        imageLink.setAttribute('aria-label', wrapper.dataset.printessPreviewAlt || 'Open personalized preview');
        imageLink.addEventListener('click', (event) => {
          event.preventDefault();
          openDialog(wrapper);
        });
      }
    };

    const hideAddOnControl = (control) => {
      if (!(control instanceof HTMLElement)) return;
      control.dataset.printessAddonControlHidden = 'true';
      control.setAttribute('aria-hidden', 'true');
    };

    const disableAddOnProductLink = (link) => {
      if (!(link instanceof HTMLAnchorElement)) return;
      link.dataset.printessAddonProductLinkDisabled = 'true';
      link.removeAttribute('href');
      link.removeAttribute('target');
      link.setAttribute('aria-disabled', 'true');
      link.tabIndex = -1;
    };

    const protectNestedAddOn = (wrapper) => {
      if (!(wrapper instanceof HTMLElement) || !wrapper.hasAttribute('data-printess-cart-addon')) return;

      const cartItemSelector = wrapper.dataset.printessCartItemSelector || '.cart-item';
      let cartItem;
      try {
        cartItem = wrapper.closest(cartItemSelector);
      } catch {
        return;
      }
      if (!cartItem) return;

      cartItem.dataset.printessProtectedAddonRow = 'true';
      const quantitySelector = wrapper.dataset.printessAddonQuantitySelector || '';
      const removeSelector = wrapper.dataset.printessAddonRemoveSelector || '';
      const addOnProductUrl = wrapper.dataset.printessAddonProductUrl || '';
      let addOnProductPath = '';
      if (addOnProductUrl) {
        try {
          addOnProductPath = new URL(addOnProductUrl, window.location.origin).pathname;
        } catch {}
      }

      if (quantitySelector) {
        try {
          cartItem.querySelectorAll(quantitySelector).forEach(hideAddOnControl);
        } catch {}
      }
      if (removeSelector) {
        try {
          cartItem.querySelectorAll(removeSelector).forEach(hideAddOnControl);
        } catch {}
      }

      cartItem.querySelectorAll('input[name^="updates"], select[name^="updates"]').forEach((quantityControl) => {
        if ('value' in quantityControl) quantityControl.value = '1';
        const quantityHost = quantityControl.closest('quantity-input') || quantityControl.parentElement || quantityControl;
        hideAddOnControl(quantityHost);
      });

      cartItem.querySelectorAll('a[href], button, input[type="submit"]').forEach((control) => {
        let isRemoveControl = control.matches('[data-cart-remove], [data-remove-item], [name="remove"]');
        if (!isRemoveControl && control instanceof HTMLAnchorElement) {
          try {
            const url = new URL(control.href, window.location.origin);
            isRemoveControl = url.pathname.endsWith('/cart/change')
              && url.searchParams.get('quantity') === '0';
            const isProductLink = addOnProductPath
              ? url.pathname === addOnProductPath
              : url.pathname.includes('/products/');
            if (isProductLink) disableAddOnProductLink(control);
          } catch {}
        }
        if (isRemoveControl) hideAddOnControl(control);
      });

      if (cartItem.dataset.printessAddonProtectionBound === 'true') return;
      cartItem.dataset.printessAddonProtectionBound = 'true';
      const keepQuantityOne = () => {
        cartItem.querySelectorAll('input[name^="updates"], select[name^="updates"]').forEach((quantityControl) => {
          if ('value' in quantityControl) quantityControl.value = '1';
        });
      };
      cartItem.addEventListener('input', keepQuantityOne, true);
      cartItem.addEventListener('change', keepQuantityOne, true);
      cartItem.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const blockedControl = target.closest('[data-printess-addon-control-hidden="true"], [data-printess-addon-product-link-disabled="true"], [data-cart-remove], [data-remove-item], [name="remove"]');
        if (!blockedControl) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
    };

    const initializeWrapper = (wrapper) => {
      if (!(wrapper instanceof HTMLElement)) return;
      protectNestedAddOn(wrapper);
      if (wrapper.dataset.printessCartInitialized === 'true') return;
      wrapper.dataset.printessCartInitialized = 'true';

      const previewTrigger = wrapper.querySelector('[data-printess-cart-preview-trigger]');
      const closeButton = wrapper.querySelector('[data-printess-cart-lightbox-close]');
      const dialog = wrapper.querySelector('[data-printess-cart-lightbox]');

      if (previewTrigger) {
        previewTrigger.addEventListener('click', (event) => {
          event.preventDefault();
          openDialog(wrapper);
        });
      }

      if (closeButton) closeButton.addEventListener('click', () => closeDialog(dialog));
      if (dialog) {
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) closeDialog(dialog);
        });
      }

      replaceProductImage(wrapper);
    };

    const initialize = (scope = document) => {
      if (scope instanceof Element && scope.matches(rootSelector)) initializeWrapper(scope);
      scope.querySelectorAll(rootSelector).forEach(initializeWrapper);
    };

    if (window.PrintessCartRuntime && typeof window.PrintessCartRuntime.initialize === 'function') {
      window.PrintessCartRuntime.initialize(document);
      return;
    }

    window.PrintessCartRuntime = { initialize };

    const start = () => {
      initialize(document);
      const observer = new MutationObserver((records) => {
        records.forEach((record) => {
          record.addedNodes.forEach((node) => {
            if (node instanceof Element) initialize(node);
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["printess-slim-ui"] && !Shopify.designMode) return;
  try {
    (() => {
    const rootSelector = '[data-printess-slim-ui]';

    const parseJson = (value, fallback) => {
      try {
        return JSON.parse(value);
      } catch (error) {
        return fallback;
      }
    };

    const getErrorMessages = (error) => {
      const errors = Array.isArray(error) ? error : error && Array.isArray(error.errors) ? error.errors : [error];
      return errors
        .map((item) => {
          if (typeof item === 'string') return item;
          if (item && typeof item.errorMessage === 'string') return item.errorMessage;
          if (item && typeof item.message === 'string') return item.message;
          return '';
        })
        .filter(Boolean);
    };

    const formatError = (error, fallback) => {
      const messages = getErrorMessages(error);
      return messages.length ? messages.join(' ') : fallback;
    };

    const initialize = async (root) => {
      if (root.dataset.printessInitialized) return;
      root.dataset.printessInitialized = 'loading';

      const configNode = root.querySelector('[data-printess-config]');
      const config = configNode ? parseJson(configNode.textContent, null) : null;
      const controls = root.querySelector('[data-printess-controls]');
      const uiContainer = root.querySelector('[data-printess-ui]');
      const errorNode = root.querySelector('[data-printess-error]');
      const reviewButton = root.querySelector('[data-printess-review]');
      const dialog = root.querySelector('[data-printess-dialog]');
      const dialogImage = root.querySelector('[data-printess-dialog-image]');
      const dialogLoading = root.querySelector('[data-printess-dialog-loading]');
      const qualityWarning = root.querySelector('[data-printess-quality-warning]');
      const qualityWarningText = root.querySelector('[data-printess-quality-warning-text]');
      const confirmation = root.querySelector('[data-printess-confirmation]');
      const confirmCheckbox = root.querySelector('[data-printess-confirm-checkbox]');
      const legalConfirmCheckbox = root.querySelector('[data-printess-legal-confirm-checkbox]');
      const editButton = root.querySelector('[data-printess-edit]');
      const approveButton = root.querySelector('[data-printess-approve]');
      const loader = root.querySelector('[data-printess-loader]');
      const variantTransition = root.querySelector('[data-printess-variant-transition]');
      const internalPreviewContainer = root.querySelector('[data-printess-internal-preview]');
      const internalPreviewHost = root.querySelector('[data-printess-preview]');
      const internalPreviewImage = root.querySelector('[data-printess-preview-image]');
      const lightboxTrigger = root.querySelector('[data-printess-lightbox-trigger]');
      const lightbox = root.querySelector('[data-printess-lightbox]');
      const lightboxContent = root.querySelector('[data-printess-lightbox-content]');
      const lightboxImage = root.querySelector('[data-printess-lightbox-image]');
      const lightboxClose = root.querySelector('[data-printess-lightbox-close]');
      const saveTokenFields = [...root.querySelectorAll('[data-printess-save-token]')];
      const thumbnailFields = [...root.querySelectorAll('[data-printess-thumbnail]')];
      const rawCartSelectionMap = config ? parseJson(config.cartSelectionMap, []) : [];
      const cartSelectionMap = Array.isArray(rawCartSelectionMap) ? rawCartSelectionMap : [];
      let currentSelectionProperties = {};
      let currentSelectedAddOns = [];

      const queryDocument = (selector) => {
        if (!selector) return null;
        try {
          return document.querySelector(selector);
        } catch (error) {
          return null;
        }
      };

      const queryWithin = (container, selector) => {
        if (!container || !selector) return null;
        try {
          return container.querySelector(selector);
        } catch (error) {
          return null;
        }
      };

      let highlightedValidationTargets = [];

      const clearValidationHighlights = () => {
        highlightedValidationTargets.forEach((target) => {
          target.classList.remove('printess-slim-ui__validation-target');
        });
        highlightedValidationTargets = [];
      };

      const setError = (message, problems = []) => {
        clearValidationHighlights();
        errorNode.replaceChildren();

        const normalizedProblems = Array.isArray(problems) ? problems.filter(Boolean) : [];
        const hasMessage = typeof message === 'string' && message.trim();
        if (!hasMessage && !normalizedProblems.length) {
          errorNode.hidden = true;
          return;
        }

        if (hasMessage) {
          const summary = document.createElement('div');
          summary.className = 'printess-slim-ui__error-summary';
          summary.textContent = message.trim();
          errorNode.appendChild(summary);
        }

        if (normalizedProblems.length) {
          const list = document.createElement('ul');
          list.className = 'printess-slim-ui__error-list';
          normalizedProblems.forEach((problem) => {
            const item = document.createElement('li');
            item.textContent = problem.label
              ? `${problem.label}: ${problem.message}`
              : problem.message;
            list.appendChild(item);

            if (problem.target instanceof HTMLElement && !highlightedValidationTargets.includes(problem.target)) {
              problem.target.classList.add('printess-slim-ui__validation-target');
              highlightedValidationTargets.push(problem.target);
            }
          });
          errorNode.appendChild(list);
        }

        errorNode.hidden = false;
      };

      const formById = config && config.formId ? document.getElementById(config.formId) : null;
      const formBySelector = config ? queryDocument(config.formSelector) : null;
      const form = formById || formBySelector || root.closest('form');

      const hideSecondaryBuyAreas = () => {
        if (!config || !config.hideSecondaryBuyArea || !config.secondaryBuySelector) return;

        let secondaryBuyAreas;
        try {
          secondaryBuyAreas = document.querySelectorAll(config.secondaryBuySelector);
        } catch (error) {
          return;
        }

        secondaryBuyAreas.forEach((area) => {
          if (form && (area === form || area.contains(form))) return;
          area.classList.add('printess-slim-ui__secondary-buy-hidden');
          area.dataset.printessSecondaryBuyHiddenFor = root.id;
        });
      };

      hideSecondaryBuyAreas();

      if (!config || !form) {
        setError(config && config.messages ? config.messages.configuration : 'Printess configuration is incomplete.');
        root.dataset.printessInitialized = 'error';
        return;
      }

      const activeCurrency = String(
        window.Shopify
          && window.Shopify.currency
          && window.Shopify.currency.active
          ? window.Shopify.currency.active
          : config.currency || ''
      ).trim().toUpperCase();
      const addOnFields = new Map();
      const selectedAddOnValues = new Map();
      const priceCategoryLabels = {};
      let addOnConfigurationValid = true;

      const rawAddOnConfiguration = config.enableAddOns
        ? parseJson(config.addOnMap, null)
        : { fields: {} };
      const rawAddOnFields = rawAddOnConfiguration
        && typeof rawAddOnConfiguration === 'object'
        && !Array.isArray(rawAddOnConfiguration)
        && rawAddOnConfiguration.fields
        && typeof rawAddOnConfiguration.fields === 'object'
        && !Array.isArray(rawAddOnConfiguration.fields)
        ? rawAddOnConfiguration.fields
        : null;

      const getConfiguredDisplayPrice = (valueConfiguration) => {
        if (!valueConfiguration) return '';
        const prices = valueConfiguration.displayPrices;
        if (prices && typeof prices === 'object' && !Array.isArray(prices)) {
          const currencyPrice = prices[activeCurrency];
          const defaultPrice = prices.default || prices.DEFAULT;
          if (typeof currencyPrice === 'string' && currencyPrice.trim()) return currencyPrice.trim();
          if (typeof defaultPrice === 'string' && defaultPrice.trim()) return defaultPrice.trim();
        }
        return typeof valueConfiguration.displayPrice === 'string'
          ? valueConfiguration.displayPrice.trim()
          : '';
      };

      const getConfiguredUplift = (valueConfiguration) => {
        if (!valueConfiguration || typeof valueConfiguration !== 'object') {
          return { configured: false, valid: true, value: 0 };
        }

        let configured = false;
        let rawUplift;
        const uplifts = valueConfiguration.uplifts;
        if (uplifts && typeof uplifts === 'object' && !Array.isArray(uplifts)) {
          if (Object.prototype.hasOwnProperty.call(uplifts, activeCurrency)) {
            configured = true;
            rawUplift = uplifts[activeCurrency];
          } else if (Object.prototype.hasOwnProperty.call(uplifts, 'default')) {
            configured = true;
            rawUplift = uplifts.default;
          } else if (Object.prototype.hasOwnProperty.call(uplifts, 'DEFAULT')) {
            configured = true;
            rawUplift = uplifts.DEFAULT;
          }
        } else if (Object.prototype.hasOwnProperty.call(valueConfiguration, 'uplift')) {
          configured = true;
          rawUplift = valueConfiguration.uplift;
        }

        if (!configured) return { configured: false, valid: true, value: 0 };

        const hasNumericValue = typeof rawUplift === 'number'
          || (typeof rawUplift === 'string' && rawUplift.trim() !== '');
        const numericUplift = hasNumericValue ? Number(rawUplift) : Number.NaN;
        return {
          configured: true,
          valid: Number.isFinite(numericUplift) && numericUplift >= 0,
          value: Number.isFinite(numericUplift) ? numericUplift : 0
        };
      };

      const formatAddOnPrice = (price) => {
        const normalizedPrice = typeof price === 'string' ? price.trim() : '';
        if (!normalizedPrice) return '';
        return /^[+-]/.test(normalizedPrice) ? normalizedPrice : `+${normalizedPrice}`;
      };

      if (config.enableAddOns) {
        if (!rawAddOnFields) {
          addOnConfigurationValid = false;
        } else {
          Object.entries(rawAddOnFields).forEach(([rawFieldLabel, rawFieldConfiguration]) => {
            const fieldLabel = typeof rawFieldLabel === 'string' ? rawFieldLabel.trim() : '';
            if (!fieldLabel || !rawFieldConfiguration || typeof rawFieldConfiguration !== 'object' || Array.isArray(rawFieldConfiguration)) {
              addOnConfigurationValid = false;
              return;
            }

            const rawInfo = rawFieldConfiguration.info
              && typeof rawFieldConfiguration.info === 'object'
              && !Array.isArray(rawFieldConfiguration.info)
              ? rawFieldConfiguration.info
              : {};
            const fieldConfiguration = {
              label: fieldLabel,
              formFieldName: typeof rawFieldConfiguration.formFieldName === 'string'
                ? rawFieldConfiguration.formFieldName.trim()
                : '',
              unmappedValuesAreFree: rawFieldConfiguration.unmappedValuesAreFree === true,
              infoText: typeof (rawInfo.text || rawFieldConfiguration.infoText) === 'string'
                ? String(rawInfo.text || rawFieldConfiguration.infoText).trim()
                : '',
              infoUrl: typeof (rawInfo.url || rawFieldConfiguration.infoUrl) === 'string'
                ? String(rawInfo.url || rawFieldConfiguration.infoUrl).trim()
                : '',
              infoLinkText: typeof (rawInfo.linkText || rawFieldConfiguration.infoLinkText) === 'string'
                ? String(rawInfo.linkText || rawFieldConfiguration.infoLinkText).trim()
                : '',
              values: new Map()
            };

            const rawValues = rawFieldConfiguration.values;
            if (!rawValues || typeof rawValues !== 'object' || Array.isArray(rawValues)) {
              addOnConfigurationValid = false;
              return;
            }

            Object.entries(rawValues).forEach(([rawDataValue, rawValueConfiguration]) => {
              const dataValue = typeof rawDataValue === 'string' ? rawDataValue.trim() : '';
              const valueConfiguration = rawValueConfiguration
                && typeof rawValueConfiguration === 'object'
                && !Array.isArray(rawValueConfiguration)
                ? rawValueConfiguration
                : {};
              const rawVariantId = valueConfiguration.variantId;
              const variantId = rawVariantId === null || rawVariantId === undefined || rawVariantId === ''
                ? null
                : Number(rawVariantId);
              const displayPrice = getConfiguredDisplayPrice(valueConfiguration);
              const upliftConfiguration = getConfiguredUplift(valueConfiguration);

              if (!dataValue || (variantId !== null && (!Number.isSafeInteger(variantId) || variantId <= 0))) {
                addOnConfigurationValid = false;
                return;
              }
              if (!upliftConfiguration.valid
                || (variantId === null && upliftConfiguration.value !== 0)
                || (variantId !== null && (!upliftConfiguration.configured || upliftConfiguration.value <= 0))) {
                addOnConfigurationValid = false;
                return;
              }
              if (displayPrice && variantId === null) {
                addOnConfigurationValid = false;
                return;
              }
              if (config.showAddOnPrices !== false && variantId !== null && !displayPrice) {
                addOnConfigurationValid = false;
                return;
              }

              const option = {
                dataValue,
                variantId,
                optionLabel: typeof valueConfiguration.optionLabel === 'string'
                  ? valueConfiguration.optionLabel.trim()
                  : '',
                cartLabel: typeof valueConfiguration.cartLabel === 'string'
                  ? valueConfiguration.cartLabel.trim()
                  : '',
                tag: typeof valueConfiguration.tag === 'string'
                  ? valueConfiguration.tag.trim()
                  : '',
                displayPrice,
                uplift: upliftConfiguration.value
              };
              fieldConfiguration.values.set(dataValue, option);

              if (config.showAddOnPrices !== false && option.tag && displayPrice) {
                const nativePriceLabel = displayPrice.replace(/^\+\s*/, '');
                if (priceCategoryLabels[option.tag] && priceCategoryLabels[option.tag] !== nativePriceLabel) {
                  addOnConfigurationValid = false;
                  return;
                }
                priceCategoryLabels[option.tag] = nativePriceLabel;
              }
            });

            addOnFields.set(fieldLabel, fieldConfiguration);
          });
        }
      }

      if (!addOnConfigurationValid) {
        setError(config.messages.configuration);
        root.dataset.printessInitialized = 'error';
        return;
      }

      let cropDialogScrollY = null;
      const captureCropDialogScroll = (event) => {
        const cropControlClicked = event.composedPath().some((node) => (
          node instanceof Element
          && (
            node.classList.contains('bc-image-thumb')
            || node.classList.contains('bc-image-thumb-crop')
          )
        ));
        if (cropControlClicked) cropDialogScrollY = window.scrollY;
      };

      const applyCropDialogTheme = (cropDialog) => {
        if (!(cropDialog instanceof HTMLElement)) return;

        const rootStyles = window.getComputedStyle(root);
        const accentColor = rootStyles.getPropertyValue('--printess-accent-color').trim() || '#0055A0';
        const accentTextColor = rootStyles.getPropertyValue('--printess-accent-text-color').trim() || '#FFFFFF';
        cropDialog.style.setProperty('--printess-accent-color', accentColor);
        cropDialog.style.setProperty('--printess-accent-text-color', accentTextColor);
        cropDialog.dataset.printessCropThemedFor = root.id;
        document.documentElement.classList.add('printess-slim-ui__crop-active');

        const cropSvg = cropDialog.querySelector('.bc-image-container > svg');
        if (!cropSvg) return;

        const svgWidth = Number.parseFloat(cropSvg.getAttribute('width'));
        const svgHeight = Number.parseFloat(cropSvg.getAttribute('height'));
        if (Number.isFinite(svgWidth) && svgWidth > 0 && Number.isFinite(svgHeight) && svgHeight > 0) {
          cropSvg.setAttribute('viewBox', `0 0 ${svgWidth} ${svgHeight}`);
          cropSvg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        }
      };

      const applyCropDialogThemeFromNode = (node) => {
        if (!(node instanceof Element)) return;

        const containingDialog = node.matches('sc-image-crop-rotate-overlay')
          ? node
          : node.closest('sc-image-crop-rotate-overlay');
        if (containingDialog) applyCropDialogTheme(containingDialog);

        node.querySelectorAll('sc-image-crop-rotate-overlay').forEach(applyCropDialogTheme);
      };

      const cropDialogObserver = new MutationObserver((mutations) => {
        let cropDialogRemoved = false;

        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach(applyCropDialogThemeFromNode);
          mutation.removedNodes.forEach((node) => {
            if (!(node instanceof Element)) return;
            if (node.matches('sc-image-crop-rotate-overlay') || node.querySelector('sc-image-crop-rotate-overlay')) {
              cropDialogRemoved = true;
            }
          });
        });

        if (!cropDialogRemoved) return;
        if (!document.querySelector('sc-image-crop-rotate-overlay')) {
          document.documentElement.classList.remove('printess-slim-ui__crop-active');
        }
        if (typeof cropDialogScrollY !== 'number') return;
        const scrollY = cropDialogScrollY;
        cropDialogScrollY = null;
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => window.scrollTo({ top: scrollY, behavior: 'auto' }));
        });
      });

      document.addEventListener('click', captureCropDialogScroll, true);
      document.querySelectorAll('sc-image-crop-rotate-overlay').forEach(applyCropDialogTheme);
      cropDialogObserver.observe(document.body, { childList: true, subtree: true });
      root.printessCropDialogCleanup = () => {
        document.removeEventListener('click', captureCropDialogScroll, true);
        cropDialogObserver.disconnect();
        document.querySelectorAll('sc-image-crop-rotate-overlay').forEach((dialog) => dialog.remove());
        document.documentElement.classList.remove('printess-slim-ui__crop-active');
      };

      const forceQuantityOneAndHide = () => {
        if (!config.hideQuantity) return;

        const quantityInput = form.elements.namedItem('quantity');
        if (quantityInput instanceof HTMLInputElement) {
          quantityInput.value = '1';
          quantityInput.defaultValue = '1';
          quantityInput.setAttribute('value', '1');
        }

        const quantityContainer = queryWithin(form, config.quantitySelector)
          || (quantityInput instanceof HTMLElement ? quantityInput.closest('.quantity-wrapper') : null);

        if (quantityContainer) {
          quantityContainer.classList.add('printess-slim-ui__quantity-hidden');
          quantityContainer.dataset.printessQuantityHiddenFor = root.id;
        }
      };

      forceQuantityOneAndHide();

      const hideNativeAddButtons = () => {
        hideSecondaryBuyAreas();
        forceQuantityOneAndHide();

        if (!config.addButtonSelector) return;

        let nativeAddButtons;
        try {
          nativeAddButtons = form.querySelectorAll(config.addButtonSelector);
        } catch {
          return;
        }

        nativeAddButtons.forEach((button) => {
          if (!(button instanceof HTMLElement)) return;

          if (!button.dataset.printessNativeAddHiddenFor) {
            button.dataset.printessOriginalHidden = button.hidden ? 'true' : 'false';
            button.dataset.printessHadAriaHidden = button.hasAttribute('aria-hidden') ? 'true' : 'false';
            button.dataset.printessOriginalAriaHidden = button.getAttribute('aria-hidden') || '';
            button.dataset.printessOriginalDisplay = button.style.getPropertyValue('display');
            button.dataset.printessOriginalDisplayPriority = button.style.getPropertyPriority('display');
          }

          button.dataset.printessNativeAddHiddenFor = root.id;
          button.classList.add('printess-slim-ui__native-add');
          button.hidden = true;
          button.setAttribute('aria-hidden', 'true');
          button.style.setProperty('display', 'none', 'important');
        });
      };

      hideNativeAddButtons();

      if (!config.shopToken) {
        setError(config.messages.configuration);
        root.dataset.printessInitialized = 'error';
        return;
      }

      const variants = Array.isArray(config.variants) ? config.variants : [];
      const rawVariantTemplateMap = config.variantTemplateMap;
      const variantTemplateMap = new Map();
      const rawSkuTemplateMap = parseJson(config.skuTemplateMap, null);
      const skuTemplateMap = new Map();

      if (rawVariantTemplateMap && typeof rawVariantTemplateMap === 'object' && !Array.isArray(rawVariantTemplateMap)) {
        Object.entries(rawVariantTemplateMap).forEach(([variantId, printessTemplateName]) => {
          if (typeof printessTemplateName !== 'string') return;
          const normalizedVariantId = variantId.trim();
          const normalizedTemplateName = printessTemplateName.trim();
          if (normalizedVariantId && normalizedTemplateName) {
            variantTemplateMap.set(normalizedVariantId, normalizedTemplateName);
          }
        });
      }

      if (!rawSkuTemplateMap || typeof rawSkuTemplateMap !== 'object' || Array.isArray(rawSkuTemplateMap)) {
        setError(config.messages.configuration);
        root.dataset.printessInitialized = 'error';
        return;
      }

      Object.entries(rawSkuTemplateMap).forEach(([sku, printessTemplateName]) => {
        if (typeof printessTemplateName !== 'string') return;
        const normalizedSku = sku.trim();
        const normalizedTemplateName = printessTemplateName.trim();
        if (normalizedSku && normalizedTemplateName) skuTemplateMap.set(normalizedSku, normalizedTemplateName);
      });

      const findVariant = (variantId) => variants.find((variant) => String(variant.id) === String(variantId));

      const getSelectedVariant = () => {
        const variantIdField = form.elements.namedItem('id');
        const variantId = variantIdField && variantIdField.value ? variantIdField.value : config.initialVariantId;
        return findVariant(variantId) || findVariant(config.initialVariantId) || {
          id: config.initialVariantId,
          sku: config.initialSku
        };
      };

      const addPersonalizedItemToCart = async () => {
        const variantIdField = form.elements.namedItem('id');
        const hasWritableVariantId = variantIdField instanceof HTMLInputElement
          || variantIdField instanceof HTMLSelectElement;
        const currentVariant = hasWritableVariantId ? findVariant(variantIdField.value) : null;
        if (!currentVariant || currentVariant.available === false) {
          throw new Error(config.messages.submit);
        }

        variantIdField.value = String(currentVariant.id);
        const variantId = Number(currentVariant.id);
        if (!Number.isSafeInteger(variantId) || variantId <= 0) {
          throw new Error(config.messages.submit);
        }

        const properties = {};
        [...saveTokenFields, ...thumbnailFields].forEach((field) => {
          if (field.disabled || !('value' in field)) return;
          if (!field.name.startsWith('properties[') || !field.name.endsWith(']')) return;
          const propertyName = field.name.slice(11, -1);
          if (propertyName) properties[propertyName] = field.value;
        });

        Object.entries(currentSelectionProperties).forEach(([propertyName, value]) => {
          if (value) properties[propertyName] = value;
        });

        if (!properties._Printess_Token || !properties._Printess_Thumbnail_URL) {
          throw new Error(config.messages.validation);
        }

        const selectedAddOns = Array.isArray(currentSelectedAddOns) ? currentSelectedAddOns : [];
        selectedAddOns.forEach((addOn) => {
          if (!addOn
            || !Number.isSafeInteger(addOn.variantId)
            || addOn.variantId <= 0
            || addOn.variantId === variantId
            || !Number.isFinite(addOn.uplift)
            || addOn.uplift <= 0) {
            throw new Error(config.messages.configuration);
          }
        });

        const totalUplift = selectedAddOns.reduce((total, addOn) => total + addOn.uplift, 0);
        const roundedUplift = Math.round((totalUplift + Number.EPSILON) * 100) / 100;
        properties._Product_Timestamp = new Date().toISOString();
        properties._uplift = roundedUplift.toFixed(2);
        properties._CustomPrice = roundedUplift > 0 ? 'true' : 'false';

        const groupId = selectedAddOns.length
          ? (window.crypto && typeof window.crypto.randomUUID === 'function'
            ? window.crypto.randomUUID()
            : `printess-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`)
          : '';

        if (selectedAddOns.length) {
          properties._Printess_Group_ID = groupId;
          properties._Printess_Addon_Data_Values = selectedAddOns.map((addOn) => addOn.dataValue).join(' | ').slice(0, 255);
          properties._Printess_Addon_Variant_IDs = selectedAddOns.map((addOn) => String(addOn.variantId)).join(' | ').slice(0, 255);
          properties._Printess_Addon_Labels = selectedAddOns.map((addOn) => addOn.label).join(' | ').slice(0, 255);
        }

        const items = [{
          id: variantId,
          quantity: 1,
          properties
        }];

        selectedAddOns.forEach((addOn) => {
          items.push({
            id: addOn.variantId,
            quantity: 1,
            parent_id: variantId,
            properties: {
              _Printess_Addon: 'true',
              _Printess_Parent_Group_ID: groupId,
              _Printess_Addon_Field: addOn.fieldLabel.slice(0, 255),
              _Printess_Addon_Data_Value: addOn.dataValue.slice(0, 255),
              _Printess_Addon_Label: addOn.label.slice(0, 255)
            }
          });
        });

        const shopRoot = window.Shopify
          && window.Shopify.routes
          && typeof window.Shopify.routes.root === 'string'
          ? window.Shopify.routes.root
          : '/';
        const cartAddUrl = new URL(`${shopRoot}cart/add.js`, window.location.origin);
        const response = await fetch(cartAddUrl.toString(), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items
          })
        });

        let responseData = null;
        try {
          responseData = await response.json();
        } catch {}

        if (!response.ok) {
          const responseMessage = responseData
            && (responseData.description || responseData.message || responseData.status);
          throw new Error(typeof responseMessage === 'string' ? responseMessage : config.messages.submit);
        }

        // window.location.assign(new URL(`${shopRoot}cart`, window.location.origin).toString());
        window.Rebuy?.SmartCart?.show?.();
      };

      const getTemplateName = (variant) => {
        const variantId = variant && variant.id ? String(variant.id).trim() : '';
        const metafieldTemplateName = config.useTemplateMetafield
          ? variantTemplateMap.get(variantId)
          : '';
        if (metafieldTemplateName) return metafieldTemplateName;

        const normalizedSku = variant && typeof variant.sku === 'string' ? variant.sku.trim() : '';
        const mappedTemplateName = skuTemplateMap.get(normalizedSku);
        if (mappedTemplateName) return mappedTemplateName;
        if (config.useSkuAsTemplateName && normalizedSku) return normalizedSku;
        return typeof config.templateName === 'string' ? config.templateName.trim() : '';
      };

      const urlParameters = new URLSearchParams(window.location.search);
      const saveTokenFromUrl = urlParameters.get('savetoken') || urlParameters.get('printessSaveToken');
      const selectedVariant = getSelectedVariant();
      const selectedSku = typeof selectedVariant.sku === 'string' ? selectedVariant.sku.trim() : '';
      const selectedTemplateName = saveTokenFromUrl || getTemplateName(selectedVariant);

      if (!selectedTemplateName) {
        const skuMessage = selectedSku ? ` SKU: ${selectedSku}` : '';
        setError(`${config.messages.skuTemplate || config.messages.configuration}${skuMessage}`);
        root.dataset.printessInitialized = 'error';
        return;
      }

      [...saveTokenFields, ...thumbnailFields].forEach((field) => {
        if (field.form !== form) form.append(field);
      });

      const productDetailContainer = form.closest('.product-detail');
      let productPriceNode = config.showCombinedPrice
        ? queryWithin(productDetailContainer, config.productPriceSelector)
          || queryDocument(config.productPriceSelector)
        : null;
      let originalProductPriceHtml = productPriceNode ? productPriceNode.innerHTML : '';
      let originalProductPriceAriaLabel = productPriceNode
        ? productPriceNode.getAttribute('aria-label')
        : null;
      let originalProductPriceColor = productPriceNode
        ? productPriceNode.style.getPropertyValue('color')
        : '';
      let originalProductPriceColorPriority = productPriceNode
        ? productPriceNode.style.getPropertyPriority('color')
        : '';
      let originalProductPriceVariantId = String(selectedVariant.id || '');
      let combinedPriceNoteNode = null;

      const restoreVisualProductPrice = () => {
        if (productPriceNode && productPriceNode.dataset.printessCombinedPriceFor === root.id) {
          productPriceNode.innerHTML = originalProductPriceHtml;
          if (originalProductPriceAriaLabel === null) {
            productPriceNode.removeAttribute('aria-label');
          } else {
            productPriceNode.setAttribute('aria-label', originalProductPriceAriaLabel);
          }
          if (originalProductPriceColor) {
            productPriceNode.style.setProperty(
              'color',
              originalProductPriceColor,
              originalProductPriceColorPriority
            );
          } else {
            productPriceNode.style.removeProperty('color');
          }
          delete productPriceNode.dataset.printessCombinedPriceFor;
        }
        if (combinedPriceNoteNode) combinedPriceNoteNode.remove();
        combinedPriceNoteNode = null;
      };

      const formatCombinedProductPrice = (priceInMinorUnits) => {
        const amount = priceInMinorUnits / 100;
        try {
          return new Intl.NumberFormat(
            document.documentElement.lang || config.lang || undefined,
            {
              style: 'currency',
              currency: activeCurrency,
              currencyDisplay: 'narrowSymbol'
            }
          ).format(amount);
        } catch (error) {
          return `${activeCurrency} ${amount.toFixed(2)}`.trim();
        }
      };

      const getSelectedAddOnUplift = () => [...selectedAddOnValues.values()].reduce((total, selection) => {
        if (!selection
          || !selection.option
          || !selection.option.variantId
          || !Number.isFinite(selection.option.uplift)
          || selection.option.uplift <= 0) {
          return total;
        }
        return total + selection.option.uplift;
      }, 0);

      const updateVisualProductPrice = () => {
        if (!config.showCombinedPrice || !config.productPriceSelector) return;

        const nextProductPriceNode = queryWithin(productDetailContainer, config.productPriceSelector)
          || queryDocument(config.productPriceSelector);
        if (nextProductPriceNode && nextProductPriceNode !== productPriceNode) {
          restoreVisualProductPrice();
          productPriceNode = nextProductPriceNode;
          originalProductPriceHtml = productPriceNode.innerHTML;
          originalProductPriceAriaLabel = productPriceNode.getAttribute('aria-label');
          originalProductPriceColor = productPriceNode.style.getPropertyValue('color');
          originalProductPriceColorPriority = productPriceNode.style.getPropertyPriority('color');
        }
        if (!productPriceNode) return;

        const variant = getSelectedVariant();
        const basePrice = Number(variant && variant.price);
        const uplift = getSelectedAddOnUplift();
        if (!Number.isFinite(basePrice) || basePrice < 0) {
          restoreVisualProductPrice();
          return;
        }

        const variantId = String(variant && variant.id ? variant.id : '');
        if (variantId && variantId !== originalProductPriceVariantId) {
          const basePriceText = formatCombinedProductPrice(basePrice);
          originalProductPriceHtml = basePriceText;
          originalProductPriceAriaLabel = basePriceText;
          originalProductPriceVariantId = variantId;
        }
        if (uplift <= 0) {
          restoreVisualProductPrice();
          return;
        }

        const upliftInMinorUnits = Math.round((uplift + Number.EPSILON) * 100);
        const combinedPriceText = formatCombinedProductPrice(basePrice + upliftInMinorUnits);
        productPriceNode.textContent = combinedPriceText;
        productPriceNode.dataset.printessCombinedPriceFor = root.id;
        productPriceNode.setAttribute('aria-label', combinedPriceText);
        productPriceNode.style.setProperty('color', config.addOnPriceColor || '#D92D20', 'important');

        const noteText = typeof config.combinedPriceNote === 'string'
          ? config.combinedPriceNote.trim()
          : '';
        if (!noteText) {
          if (combinedPriceNoteNode) combinedPriceNoteNode.remove();
          combinedPriceNoteNode = null;
          return;
        }

        if (!combinedPriceNoteNode || !combinedPriceNoteNode.isConnected) {
          combinedPriceNoteNode = document.createElement('span');
          combinedPriceNoteNode.className = 'printess-slim-ui__combined-price-note';
          combinedPriceNoteNode.dataset.printessCombinedPriceNoteFor = root.id;
          combinedPriceNoteNode.setAttribute('role', 'status');
          combinedPriceNoteNode.style.setProperty(
            '--printess-add-on-price-color',
            config.addOnPriceColor || '#D92D20'
          );
          productPriceNode.insertAdjacentElement('afterend', combinedPriceNoteNode);
        }
        combinedPriceNoteNode.textContent = `(${noteText})`;
      };

      root.printessCombinedPriceCleanup = restoreVisualProductPrice;
      let previewContainer = queryWithin(productDetailContainer, config.previewContainerSelector)
        || queryWithin(productDetailContainer, '.product-media--image')
        || queryDocument(config.previewContainerSelector);
      let previewImage = queryWithin(previewContainer, config.previewImageSelector)
        || queryWithin(previewContainer, 'img.rimage__image')
        || queryWithin(productDetailContainer, config.previewImageSelector)
        || queryDocument(config.previewImageSelector);
      const usesExternalPreview = Boolean(previewContainer && previewImage && previewContainer.contains(previewImage));

      if (!usesExternalPreview) {
        root.classList.remove('printess-slim-ui--external-preview');
        previewContainer = internalPreviewHost;
        previewImage = internalPreviewImage;
      } else {
        previewContainer.classList.add('printess-slim-ui__external-preview-host');
        previewContainer.dataset.printessExternalPreviewHostFor = root.id;
        previewImage.removeAttribute('srcset');
        previewImage.removeAttribute('sizes');
        previewImage.classList.add('printess-slim-ui__external-preview-image');
        previewImage.dataset.printessExternalPreviewImageFor = root.id;
      }

      const nativeGalleryTrigger = usesExternalPreview
        ? previewImage.closest('a.show-gallery')
          || queryWithin(previewContainer, 'a.show-gallery')
          || queryWithin(productDetailContainer, 'a.show-gallery')
        : null;

      if (nativeGalleryTrigger) {
        nativeGalleryTrigger.dataset.printessNativeGalleryFor = root.id;
        nativeGalleryTrigger.dataset.printessOriginalGalleryHref = nativeGalleryTrigger.getAttribute('href') || '';
        if (lightboxTrigger) lightboxTrigger.classList.add('printess-slim-ui__lightbox-trigger--native');
      }

      const mobilePreviewMedia = window.matchMedia('(max-width: 900px)');
      const mobilePreviewEnabled = Boolean(
        usesExternalPreview
        && config.showMobilePreviewAboveReview
        && controls
        && reviewButton
        && internalPreviewContainer
        && internalPreviewHost
        && internalPreviewImage
      );
      if (mobilePreviewEnabled) {
        internalPreviewContainer.classList.add('printess-slim-ui__mobile-preview');
        controls.insertBefore(internalPreviewContainer, reviewButton);
        const mobilePreviewGallery = previewContainer.closest('.product-column-left') || previewContainer;
        mobilePreviewGallery.classList.add('printess-slim-ui__gallery-hidden-mobile');
        mobilePreviewGallery.dataset.printessGalleryHiddenFor = root.id;
      }

      const lightboxEnabled = Boolean(config.enablePreviewLightbox && lightboxTrigger && lightbox && lightboxImage);
      loader.dataset.printessLoaderFor = root.id;
      if (lightboxEnabled) {
        lightboxTrigger.dataset.printessLightboxTriggerFor = root.id;
      }

      const initialPreviewSource = previewImage.currentSrc || previewImage.src || '';
      let initialPreviewPending = true;
      let printessProgressVisible = false;
      let printessPreviewReady = false;

      const getPreviewSource = () => previewImage.currentSrc || previewImage.src || '';

      const syncNativeGallerySource = () => {
        if (!nativeGalleryTrigger) return false;
        const currentPreviewSource = getPreviewSource();
        if (!currentPreviewSource) return false;
        nativeGalleryTrigger.setAttribute('href', currentPreviewSource);
        return true;
      };

      const handleNativeGalleryClick = (event) => {
        if (!printessPreviewReady || initialPreviewPending || printessProgressVisible) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        syncNativeGallerySource();
      };

      if (nativeGalleryTrigger) {
        nativeGalleryTrigger.addEventListener('click', handleNativeGalleryClick, true);
        root.printessNativeGalleryCleanup = () => {
          nativeGalleryTrigger.removeEventListener('click', handleNativeGalleryClick, true);
        };
      }

      const syncMobilePreviewSource = () => {
        if (!mobilePreviewEnabled || !internalPreviewImage) return false;
        const currentPreviewSource = getPreviewSource();
        if (!currentPreviewSource) return false;
        if (internalPreviewImage.src !== currentPreviewSource) internalPreviewImage.src = currentPreviewSource;
        return true;
      };

      const syncLightboxSource = () => {
        if (!lightboxImage) return false;
        const currentPreviewSource = getPreviewSource();
        if (!currentPreviewSource) return false;
        if (lightboxImage.src !== currentPreviewSource) lightboxImage.src = currentPreviewSource;
        return true;
      };

      const updateLightboxAvailability = () => {
        if (!lightboxTrigger) return;
        const hasPreview = printessPreviewReady && Boolean(getPreviewSource());
        const nativeMobileTriggerVisible = Boolean(
          nativeGalleryTrigger
          && mobilePreviewEnabled
          && mobilePreviewMedia.matches
        );
        lightboxTrigger.hidden = !hasPreview || (Boolean(nativeGalleryTrigger) && !nativeMobileTriggerVisible);
        lightboxTrigger.disabled = !hasPreview || initialPreviewPending || printessProgressVisible;
        if (nativeGalleryTrigger && hasPreview) syncNativeGallerySource();
        if (mobilePreviewEnabled && internalPreviewImage) {
          internalPreviewImage.classList.toggle('printess-slim-ui__preview-image--zoomable', hasPreview);
          internalPreviewImage.tabIndex = hasPreview ? 0 : -1;
          internalPreviewImage.setAttribute('role', 'button');
          internalPreviewImage.setAttribute('aria-label', lightboxTrigger.getAttribute('aria-label') || 'Enlarge preview');
          internalPreviewImage.setAttribute('aria-disabled', hasPreview ? 'false' : 'true');
        }
        if (lightbox && lightbox.open && hasPreview) syncLightboxSource();
      };

      const updatePreviewAssetHost = () => {
        const assetHost = mobilePreviewEnabled && mobilePreviewMedia.matches
          ? internalPreviewHost
          : previewContainer;

        if (loader && loader.parentElement !== assetHost) assetHost.append(loader);
        if (lightboxEnabled && lightboxTrigger.parentElement !== assetHost) assetHost.append(lightboxTrigger);
        if (mobilePreviewEnabled && printessPreviewReady) syncMobilePreviewSource();
        if (nativeGalleryTrigger && printessPreviewReady) syncNativeGallerySource();
      };

      const updatePreviewLoading = () => {
        const show = initialPreviewPending || printessProgressVisible;
        loader.classList.toggle('printess-loader-visible', show);
        loader.setAttribute('aria-hidden', show ? 'false' : 'true');
        previewContainer.setAttribute('aria-busy', show ? 'true' : 'false');
        previewImage.classList.toggle('printess-loader-visible', show);
        if (mobilePreviewEnabled) {
          internalPreviewHost.setAttribute('aria-busy', show ? 'true' : 'false');
          internalPreviewImage.classList.toggle('printess-loader-visible', show);
        }
        updateLightboxAvailability();
      };

      const handleMobilePreviewChange = () => {
        updatePreviewAssetHost();
        updatePreviewLoading();
      };

      if (mobilePreviewEnabled) {
        mobilePreviewMedia.addEventListener('change', handleMobilePreviewChange);
        root.printessMobilePreviewCleanup = () => {
          mobilePreviewMedia.removeEventListener('change', handleMobilePreviewChange);
        };
      }

      updatePreviewAssetHost();

      previewImage.addEventListener('load', () => {
        const currentPreviewSource = getPreviewSource();
        if (!currentPreviewSource || currentPreviewSource === initialPreviewSource) return;
        printessPreviewReady = true;
        initialPreviewPending = false;
        syncMobilePreviewSource();
        syncNativeGallerySource();
        updatePreviewLoading();
      });

      previewImage.addEventListener('error', () => {
        initialPreviewPending = false;
        printessProgressVisible = false;
        printessPreviewReady = false;
        if (lightbox && lightbox.open) lightbox.close();
        updatePreviewLoading();
      });

      updatePreviewLoading();

      const openPreview = () => {
        if (!printessPreviewReady || initialPreviewPending || printessProgressVisible) return;

        if (nativeGalleryTrigger && syncNativeGallerySource()) {
          nativeGalleryTrigger.click();
          return;
        }

        if (lightbox && syncLightboxSource()) lightbox.showModal();
      };

      if (lightboxTrigger && lightbox && lightboxImage && lightboxClose) {
        lightboxTrigger.addEventListener('click', () => {
          if (lightboxTrigger.disabled) return;
          openPreview();
        });

        if (mobilePreviewEnabled && internalPreviewImage) {
          internalPreviewImage.addEventListener('click', openPreview);
          internalPreviewImage.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            openPreview();
          });
        }

        lightboxClose.addEventListener('click', () => lightbox.close());

        lightbox.addEventListener('click', (event) => {
          if (event.target === lightbox || event.target === lightboxContent) lightbox.close();
        });
      }

      const productFormContainer = form.closest('.product-form');
      let uiMountTarget = null;
      let slimUiMaintenanceScheduled = false;

      const getBaseFieldLabel = (labelNode) => {
        if (!(labelNode instanceof Element)) return '';
        if (labelNode.dataset.printessAddOnBaseLabel) return labelNode.dataset.printessAddOnBaseLabel;

        const clone = labelNode.cloneNode(true);
        clone.querySelectorAll('.printess-slim-ui__addon-selected-price, .printess-slim-ui__addon-info').forEach((node) => node.remove());
        return clone.textContent.replace(/\s+/g, ' ').trim();
      };

      const findAddOnFieldContainer = (fieldConfiguration) => {
        if (!fieldConfiguration || !uiContainer) return null;
        return [...uiContainer.querySelectorAll('.bc-label')].find((candidate) => {
          const labelNode = candidate.querySelector(':scope > .bc-label-text');
          return getBaseFieldLabel(labelNode) === fieldConfiguration.label;
        }) || null;
      };

      const getFieldConfiguration = (formFieldName, fieldLabel) => {
        const normalizedFieldLabel = typeof fieldLabel === 'string' ? fieldLabel.trim() : '';
        if (normalizedFieldLabel && addOnFields.has(normalizedFieldLabel)) {
          return addOnFields.get(normalizedFieldLabel);
        }

        const normalizedFormFieldName = typeof formFieldName === 'string' ? formFieldName.trim() : '';
        if (!normalizedFormFieldName) return null;
        return [...addOnFields.values()].find((fieldConfiguration) => (
          fieldConfiguration.formFieldName === normalizedFormFieldName
        )) || null;
      };

      const setSelectedAddOnValue = (fieldConfiguration, dataValue, optionLabel = '', tag = '') => {
        if (!fieldConfiguration) return;
        const normalizedDataValue = typeof dataValue === 'string' ? dataValue.trim() : String(dataValue || '').trim();
        const option = fieldConfiguration.values.get(normalizedDataValue) || null;
        selectedAddOnValues.set(fieldConfiguration.label, {
          dataValue: normalizedDataValue,
          option,
          optionLabel: typeof optionLabel === 'string' ? optionLabel.trim() : '',
          tag: typeof tag === 'string' ? tag.trim() : ''
        });
      };

      const handleAddOnFieldChange = (formFieldName, dataValue, tag, optionLabel, fieldLabel) => {
        const fieldConfiguration = getFieldConfiguration(formFieldName, fieldLabel);
        if (!fieldConfiguration) return;
        setSelectedAddOnValue(fieldConfiguration, dataValue, optionLabel, tag);
        window.requestAnimationFrame(() => {
          decorateAddOnFields();
        });
      };

      const getSelectedOptionText = (fieldContainer) => {
        if (!fieldContainer) return '';
        const selectedControl = fieldContainer.querySelector('[role="option"]');
        if (!selectedControl) return '';
        const clone = selectedControl.cloneNode(true);
        clone.querySelectorAll('.price-badge, .printess-slim-ui__addon-option-price').forEach((node) => node.remove());
        return clone.textContent.replace(/\s+/g, ' ').trim();
      };

      const syncAddOnSelectionsFromDom = () => {
        addOnFields.forEach((fieldConfiguration) => {
          if (!fieldConfiguration.values.size) return;
          const fieldContainer = findAddOnFieldContainer(fieldConfiguration);
          if (!fieldContainer) return;

          const selectedOptionText = getSelectedOptionText(fieldContainer);
          if (!selectedOptionText) return;
          const matchedOption = [...fieldConfiguration.values.values()].find((option) => (
            option.optionLabel
            && (selectedOptionText === option.optionLabel || selectedOptionText.startsWith(`${option.optionLabel} `))
          ));
          if (matchedOption) {
            setSelectedAddOnValue(fieldConfiguration, matchedOption.dataValue, matchedOption.optionLabel, matchedOption.tag);
          } else {
            const currentSelection = selectedAddOnValues.get(fieldConfiguration.label);
            if (!currentSelection
              || currentSelection.option
              || currentSelection.optionLabel !== selectedOptionText) {
              selectedAddOnValues.set(fieldConfiguration.label, {
                dataValue: '',
                option: null,
                optionLabel: selectedOptionText,
                tag: ''
              });
            }
          }
        });
      };

      const getSafeInfoUrl = (rawUrl) => {
        if (!rawUrl) return '';
        try {
          const url = new URL(rawUrl, window.location.origin);
          return url.protocol === 'https:' || url.protocol === 'http:' ? url.toString() : '';
        } catch {
          return '';
        }
      };

      const createAddOnInfo = (fieldConfiguration, index) => {
        if (!fieldConfiguration.infoText && !fieldConfiguration.infoUrl) return null;

        const wrapper = document.createElement('span');
        wrapper.className = 'printess-slim-ui__addon-info';
        wrapper.dataset.printessAddOnInfo = fieldConfiguration.label;

        const tooltipId = `${root.id}-addon-info-${index}`;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'printess-slim-ui__addon-info-button';
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', tooltipId);
        button.setAttribute('aria-label', `${config.messages.addOnInfoAria || 'More information about'} ${fieldConfiguration.label}`);

        const glyph = document.createElement('span');
        glyph.className = 'printess-slim-ui__addon-info-glyph';
        glyph.textContent = 'i';
        glyph.setAttribute('aria-hidden', 'true');
        button.appendChild(glyph);

        const tooltip = document.createElement('span');
        tooltip.id = tooltipId;
        tooltip.className = 'printess-slim-ui__addon-info-tooltip';
        tooltip.setAttribute('role', 'tooltip');

        if (fieldConfiguration.infoText) {
          const text = document.createElement('span');
          text.textContent = fieldConfiguration.infoText;
          tooltip.appendChild(text);
        }

        const safeUrl = getSafeInfoUrl(fieldConfiguration.infoUrl);
        if (safeUrl) {
          const link = document.createElement('a');
          link.href = safeUrl;
          link.textContent = fieldConfiguration.infoLinkText || config.messages.addOnInfoLink || 'Learn more';
          tooltip.appendChild(link);
        }

        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const isOpen = wrapper.dataset.open === 'true';
          root.querySelectorAll('[data-printess-add-on-info][data-open="true"]').forEach((openInfo) => {
            openInfo.dataset.open = 'false';
            const openButton = openInfo.querySelector('.printess-slim-ui__addon-info-button');
            if (openButton) openButton.setAttribute('aria-expanded', 'false');
          });
          wrapper.dataset.open = isOpen ? 'false' : 'true';
          button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        });
        tooltip.addEventListener('click', (event) => event.stopPropagation());

        wrapper.append(button, tooltip);
        return wrapper;
      };

      const decorateAddOnFields = () => {
        syncAddOnSelectionsFromDom();
        [...addOnFields.values()].forEach((fieldConfiguration, index) => {
          const fieldContainer = findAddOnFieldContainer(fieldConfiguration);
          const labelNode = fieldContainer
            ? fieldContainer.querySelector(':scope > .bc-label-text')
            : null;
          if (!labelNode) return;

          const baseLabel = getBaseFieldLabel(labelNode);
          if (!baseLabel) return;
          labelNode.dataset.printessAddOnBaseLabel = baseLabel;
          labelNode.classList.add('printess-slim-ui__addon-field-label');

          const selection = selectedAddOnValues.get(fieldConfiguration.label);
          const selectedPrice = config.showAddOnPrices !== false
            && selection
            && selection.option
            && selection.option.variantId
            ? formatAddOnPrice(selection.option.displayPrice)
            : '';
          let selectedPriceNode = labelNode.querySelector(':scope > .printess-slim-ui__addon-selected-price');
          const addedText = config.messages && typeof config.messages.addOnAdded === 'string'
            ? config.messages.addOnAdded.trim()
            : '';
          const selectedPriceText = selectedPrice
            ? `${selectedPrice}${addedText ? ` ${addedText}` : ''}`
            : '';
          const existingInfoNode = labelNode.querySelector(':scope > .printess-slim-ui__addon-info');
          if (selectedPriceText) {
            if (!selectedPriceNode) {
              selectedPriceNode = document.createElement('span');
              selectedPriceNode.className = 'printess-slim-ui__addon-selected-price';
              labelNode.insertBefore(selectedPriceNode, existingInfoNode);
            }
            if (selectedPriceNode.textContent !== selectedPriceText) selectedPriceNode.textContent = selectedPriceText;
          } else if (selectedPriceNode) {
            selectedPriceNode.remove();
          }

          let infoNode = labelNode.querySelector(':scope > .printess-slim-ui__addon-info');
          if (!infoNode) {
            const info = createAddOnInfo(fieldConfiguration, index);
            if (info) {
              labelNode.appendChild(info);
              infoNode = info;
            }
          }
          if (infoNode && labelNode.lastElementChild !== infoNode) labelNode.appendChild(infoNode);
        });
        updateVisualProductPrice();
      };

      let activeAddOnField = null;
      const getAddOnPopupOption = (optionNode) => {
        if (!(optionNode instanceof HTMLElement) || !activeAddOnField) {
          return { dataValue: '', option: null, optionLabel: '' };
        }

        const dataValueNode = optionNode.matches('[data-value]')
          ? optionNode
          : optionNode.querySelector('[data-value]');
        const dataValue = dataValueNode instanceof HTMLElement
          ? dataValueNode.dataset.value || ''
          : '';
        let option = activeAddOnField.values.get(dataValue) || null;

        const clone = optionNode.cloneNode(true);
        clone.querySelectorAll('.price-badge, .printess-slim-ui__addon-option-price').forEach((node) => node.remove());
        const optionLabel = clone.textContent.replace(/\s+/g, ' ').trim();
        if (!option && optionLabel) {
          option = [...activeAddOnField.values.values()].find((candidate) => (
            candidate.optionLabel
            && (optionLabel === candidate.optionLabel || optionLabel.startsWith(`${candidate.optionLabel} `))
          )) || null;
        }

        return { dataValue, option, optionLabel };
      };

      const decorateAddOnPopup = () => {
        if (!activeAddOnField || config.showAddOnPrices === false) return;
        document.querySelectorAll('#printess-bc-combo-list').forEach((popup) => {
          popup.dataset.printessOwned = 'true';
          popup.style.setProperty('--printess-add-on-price-color', config.addOnPriceColor || '#D92D20');
          const optionNodes = new Set();
          popup.querySelectorAll('[data-value], [id^="combo_item_"]').forEach((candidate) => {
            const row = candidate.closest('[id^="combo_item_"]') || candidate;
            if (row instanceof HTMLElement) optionNodes.add(row);
          });
          optionNodes.forEach((optionNode) => {
            const { option } = getAddOnPopupOption(optionNode);
            const price = option ? formatAddOnPrice(option.displayPrice) : '';
            const nativePrice = optionNode.querySelector('.price-badge');
            const nativePriceText = nativePrice ? nativePrice.textContent.replace(/\s+/g, ' ').trim() : '';
            const priceHost = optionNode.querySelector('.bc-text-image-item > .bc-control:last-child') || optionNode;
            let priceNode = optionNode.querySelector('.printess-slim-ui__addon-option-price');
            if (!price || nativePriceText) {
              if (priceNode) priceNode.remove();
              return;
            }
            if (!priceNode) {
              priceNode = document.createElement('span');
              priceNode.className = 'printess-slim-ui__addon-option-price';
              priceHost.appendChild(priceNode);
            }
            if (priceNode.textContent !== price) priceNode.textContent = price;
            priceNode.style.color = config.addOnPriceColor || '#D92D20';
          });
        });
      };

      const handleAddOnDocumentClick = (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        const popupOption = target.closest('#printess-bc-combo-list [data-value], #printess-bc-combo-list [id^="combo_item_"]');
        if (popupOption && activeAddOnField) {
          const popupSelection = getAddOnPopupOption(popupOption);
          setSelectedAddOnValue(
            activeAddOnField,
            popupSelection.dataValue || (popupSelection.option ? popupSelection.option.dataValue : ''),
            popupOption.getAttribute('data-label') || popupSelection.optionLabel,
            popupSelection.option ? popupSelection.option.tag : ''
          );
          window.requestAnimationFrame(decorateAddOnFields);
          return;
        }

        const fieldContainer = target.closest('.bc-label');
        if (fieldContainer && uiContainer.contains(fieldContainer)) {
          const labelNode = fieldContainer.querySelector(':scope > .bc-label-text');
          const fieldLabel = getBaseFieldLabel(labelNode);
          activeAddOnField = addOnFields.get(fieldLabel) || null;
          if (activeAddOnField) window.requestAnimationFrame(decorateAddOnPopup);
        }

        if (!target.closest('.printess-slim-ui__addon-info')) {
          root.querySelectorAll('[data-printess-add-on-info][data-open="true"]').forEach((openInfo) => {
            openInfo.dataset.open = 'false';
            const openButton = openInfo.querySelector('.printess-slim-ui__addon-info-button');
            if (openButton) openButton.setAttribute('aria-expanded', 'false');
          });
        }
      };

      const collectSelectedAddOns = () => {
        syncAddOnSelectionsFromDom();
        const selections = [];
        addOnFields.forEach((fieldConfiguration) => {
          if (!fieldConfiguration.values.size) return;
          const fieldContainer = findAddOnFieldContainer(fieldConfiguration);
          const selection = selectedAddOnValues.get(fieldConfiguration.label);
          if (!fieldContainer && !selection) return;
          if (!selection || !selection.option) {
            if (fieldConfiguration.unmappedValuesAreFree) return;
            throw new Error(config.messages.configuration);
          }
          if (!selection.option.variantId) return;
          selections.push({
            fieldLabel: fieldConfiguration.label,
            dataValue: selection.option.dataValue,
            variantId: selection.option.variantId,
            label: selection.option.cartLabel || selection.option.optionLabel || selection.option.dataValue,
            uplift: selection.option.uplift
          });
        });
        return selections;
      };

      const collectCartSelectionProperties = () => {
        const selectionProperties = {};
        const fieldContainers = [...uiContainer.querySelectorAll('.bc-label')];

        cartSelectionMap.forEach((mapping) => {
          if (!mapping || typeof mapping !== 'object') return;

          const label = typeof mapping.label === 'string' ? mapping.label.trim() : '';
          const propertyName = typeof mapping.property === 'string' ? mapping.property.trim() : '';
          if (!label || !/^_[A-Za-z0-9_]{1,80}$/.test(propertyName)) return;

          const fieldContainer = fieldContainers.find((candidate) => {
            const labelNode = candidate.querySelector(':scope > .bc-label-text');
            return getBaseFieldLabel(labelNode) === label;
          });
          if (!fieldContainer) return;

          const textControl = fieldContainer.querySelector('input.bc-text-input, textarea.bc-text-input');
          const selectedOption = fieldContainer.querySelector('[role="option"]');
          const rawValue = textControl ? textControl.value : selectedOption ? selectedOption.textContent : '';
          const value = typeof rawValue === 'string' ? rawValue.trim() : '';
          if (value) selectionProperties[propertyName] = value.slice(0, 255);
        });

        return selectionProperties;
      };

      const clearResolvedImageValidationErrors = () => {
        uiContainer.querySelectorAll('.bc-upload-hint').forEach((uploadHint) => {
          const thumbnail = uploadHint.querySelector('.bc-image-thumb');
          const cropButton = uploadHint.querySelector('.bc-image-thumb-crop');
          if (!thumbnail || !cropButton) return;

          const backgroundImage = thumbnail.style.backgroundImage
            || window.getComputedStyle(thumbnail).backgroundImage;
          if (!backgroundImage || backgroundImage === 'none' || /default\.svg/i.test(backgroundImage)) return;

          uploadHint.querySelectorAll(':scope > .bc-error.sub-inline').forEach((validationError) => {
            validationError.remove();
          });
        });
      };

      const normalizeValidationText = (value) => String(value || '').replace(/\s+/g, ' ').trim();

      const getValidationProblemLabel = (validationError) => {
        const fieldContainer = validationError.closest('.bc-label');
        if (fieldContainer) {
          const labelNode = fieldContainer.querySelector(':scope > .bc-label-text')
            || [...fieldContainer.children].find((child) => child.tagName === 'LABEL');
          const label = getBaseFieldLabel(labelNode);
          if (label) return label;
        }

        const uploadContainer = validationError.closest('.bc-upload-hint');
        if (uploadContainer) {
          const uploadButton = uploadContainer.querySelector('button, .sc-upload-button, label[for="bc-image-upload-input"]');
          const uploadLabel = uploadButton
            ? normalizeValidationText(uploadButton.getAttribute('aria-label') || uploadButton.textContent)
            : '';
          if (uploadLabel) return uploadLabel;
        }

        return '';
      };

      const collectValidationProblems = () => {
        const seen = new Set();
        const problems = [];

        uiContainer.querySelectorAll('.bc-error.sub-inline').forEach((validationError) => {
          if (!(validationError instanceof HTMLElement)) return;
          const styles = window.getComputedStyle(validationError);
          if (styles.display === 'none' || styles.visibility === 'hidden') return;

          const message = normalizeValidationText(validationError.textContent);
          if (!message) return;

          const target = validationError.closest('.bc-label, .bc-upload-hint') || validationError;
          const label = getValidationProblemLabel(validationError);
          const key = `${label}\u0000${message}`;
          if (seen.has(key)) return;
          seen.add(key);
          problems.push({ label, message, target });
        });

        return problems;
      };

      const waitForValidationRendering = () => new Promise((resolve) => {
        window.requestAnimationFrame(() => window.requestAnimationFrame(resolve));
      });

      const focusValidationProblem = (problem) => {
        if (!problem || !(problem.target instanceof HTMLElement)) return;

        problem.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const focusTarget = problem.target.matches('input, textarea, select, button, [tabindex]')
          ? problem.target
          : problem.target.querySelector('input, textarea, select, button, [tabindex]');
        if (!(focusTarget instanceof HTMLElement)) return;

        try {
          focusTarget.focus({ preventScroll: true });
        } catch (error) {
          focusTarget.focus();
        }
      };

      const showValidationError = async (error) => {
        await waitForValidationRendering();
        clearResolvedImageValidationErrors();
        const problems = collectValidationProblems();
        if (!problems.length) {
          setError(formatError(error, config.messages.validation));
          return;
        }

        setError(config.messages.validation, problems);
        focusValidationProblem(problems[0]);
      };

      const collectQualityHints = () => {
        const hints = [];
        const visitedScopes = new Set();

        const visit = (scope) => {
          if (!scope || visitedScopes.has(scope)) return;
          visitedScopes.add(scope);

          scope.querySelectorAll('.sc-scale-hint, button[class*="bc-scale-warning-color-"]').forEach((hint) => {
            if (!hints.includes(hint)) hints.push(hint);
          });

          scope.querySelectorAll('*').forEach((element) => {
            if (element.shadowRoot) visit(element.shadowRoot);
          });
        };

        visit(uiContainer);
        return hints;
      };

      const makeQualityHintInformational = (hint) => {
        if (!(hint instanceof HTMLButtonElement)) return;

        hint.type = 'button';
        hint.tabIndex = -1;
        hint.setAttribute('aria-disabled', 'true');
        if (hint.dataset.printessInformationalHint === 'true') return;

        hint.dataset.printessInformationalHint = 'true';
        hint.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
        }, true);
      };

      const syncVeryLowQualityHelpText = () => {
        const helpEnabled = config.showImageQualityMessages !== false
          && config.showVeryLowQualityHelp !== false;
        const helpText = helpEnabled
          && config
          && config.messages
          && typeof config.messages.veryLowQualityHelp === 'string'
          ? config.messages.veryLowQualityHelp.trim()
          : '';

        collectQualityHints().forEach((hint) => {
          makeQualityHintInformational(hint);
          const messageNode = hint.querySelector(':scope > div:last-child');
          if (!messageNode) return;

          const existingHelp = messageNode.querySelector(':scope > .printess-slim-ui__very-low-quality-help');
          const isVeryLowQuality = hint.classList.contains('bc-scale-warning-color-red');

          if (!isVeryLowQuality || !helpText) {
            if (existingHelp) existingHelp.remove();
            return;
          }

          const renderedHelpText = ` ${helpText}`;
          if (existingHelp) {
            if (existingHelp.textContent !== renderedHelpText) existingHelp.textContent = renderedHelpText;
            return;
          }

          const help = document.createElement('span');
          help.className = 'printess-slim-ui__very-low-quality-help';
          help.textContent = renderedHelpText;
          messageNode.appendChild(help);
        });
      };

      const scheduleSlimUiMaintenance = () => {
        if (slimUiMaintenanceScheduled) return;
        slimUiMaintenanceScheduled = true;
        window.requestAnimationFrame(() => {
          slimUiMaintenanceScheduled = false;
          clearResolvedImageValidationErrors();
          syncVeryLowQualityHelpText();
          decorateAddOnFields();
        });
      };

      const installCropDpiRefreshWorkaround = (printessState) => {
        if (!printessState || printessState.__whiteMountainCropDpiRefreshInstalled) return;
        if (typeof printessState.setImageCrop !== 'function' || typeof printessState.resetImageCrop !== 'function') return;

        const updateImageScale = (state, propertyId, nextScale, rerenderUi) => {
          const property = state.propertiesById && typeof state.propertiesById.get === 'function'
            ? state.propertiesById.get(propertyId)
            : null;
          const numericScale = Number(nextScale);
          if (!property || !property.imageMeta || !Number.isFinite(numericScale) || numericScale <= 0) return;
          if (Math.abs(Number(property.imageMeta.scale) - numericScale) < 0.0001) return;

          property.imageMeta.scale = numericScale;
          if (rerenderUi && typeof state.renderUi === 'function') state.renderUi();
        };

        const originalSetImageCrop = printessState.setImageCrop;
        printessState.setImageCrop = function setImageCropWithCurrentDpi(propertyId, crop, rotation, renderPreview = true) {
          const result = originalSetImageCrop.call(this, propertyId, crop, rotation, renderPreview);
          updateImageScale(this, propertyId, crop && crop.widthScale, renderPreview);
          return result;
        };

        const originalResetImageCrop = printessState.resetImageCrop;
        printessState.resetImageCrop = function resetImageCropWithCurrentDpi(propertyId, renderPreview = true) {
          const result = originalResetImageCrop.call(this, propertyId, renderPreview);
          const property = this.propertiesById && typeof this.propertiesById.get === 'function'
            ? this.propertiesById.get(propertyId)
            : null;
          updateImageScale(this, propertyId, property && property.imageMeta && property.imageMeta.scaleHints
            ? property.imageMeta.scaleHints.min
            : null, renderPreview);
          return result;
        };

        printessState.__whiteMountainCropDpiRefreshInstalled = true;
      };

      const syncDialogQualityWarning = () => {
        if (!qualityWarning || !qualityWarningText || !dialog) return;

        if (config.showImageQualityMessages === false || config.showReviewImageQualityMessage === false) {
          qualityWarningText.textContent = '';
          qualityWarning.hidden = true;
          delete qualityWarning.dataset.qualitySeverity;
          dialog.classList.remove('printess-slim-ui__dialog--has-quality-warning');
          return;
        }

        syncVeryLowQualityHelpText();

        const inlineMessageHidden = config.showInlineImageQualityMessage === false;
        const visibleHints = collectQualityHints().filter((hint) => {
          if (hint.hidden) return false;

          if (inlineMessageHidden) {
            const uploadContainer = hint.closest('.sc-upload-button-container');
            if (!uploadContainer) return true;
            const containerStyle = window.getComputedStyle(uploadContainer);
            return containerStyle.display !== 'none'
              && containerStyle.visibility !== 'hidden'
              && uploadContainer.getClientRects().length > 0;
          }

          const style = window.getComputedStyle(hint);
          return style.display !== 'none'
            && style.visibility !== 'hidden'
            && hint.getClientRects().length > 0;
        });
        const messages = [...new Set(visibleHints.map((hint) => {
          const messageNode = hint.querySelector(':scope > div:last-child');
          const message = messageNode ? messageNode.textContent : hint.textContent;
          return typeof message === 'string' ? message.replace(/\s+/g, ' ').trim() : '';
        }).filter(Boolean))];

        qualityWarningText.textContent = messages.join('\n');
        qualityWarning.hidden = messages.length === 0;
        dialog.classList.toggle('printess-slim-ui__dialog--has-quality-warning', messages.length > 0);

        if (!messages.length) {
          delete qualityWarning.dataset.qualitySeverity;
          return;
        }

        const hasError = visibleHints.some((hint) => hint.classList.contains('bc-scale-warning-color-red'));
        const hasWarning = visibleHints.some((hint) => hint.classList.contains('bc-scale-warning-color-orange'));
        qualityWarning.dataset.qualitySeverity = hasError ? 'error' : hasWarning ? 'warning' : 'success';
      };

      if (config.uiMountSelector) {
        try {
          uiMountTarget = productFormContainer ? productFormContainer.querySelector(config.uiMountSelector) : null;
        } catch (error) {
          uiMountTarget = null;
        }
        if (!uiMountTarget) uiMountTarget = queryDocument(config.uiMountSelector);
      }

      if (controls && uiMountTarget) {
        document.querySelectorAll('[data-printess-controls-for]').forEach((existingControls) => {
          if (existingControls !== controls && existingControls.dataset.printessControlsFor === root.id) {
            existingControls.remove();
          }
        });
        const uiMountVisibilityContainer = uiMountTarget.closest('.input-row');
        if (uiMountVisibilityContainer) {
          uiMountVisibilityContainer.classList.add('printess-slim-ui__mount-visible');
          uiMountVisibilityContainer.dataset.printessMountVisibleFor = root.id;
          if (config.hideOptionSelectionHeading) {
            uiMountVisibilityContainer.classList.add('printess-slim-ui__option-heading-hidden');
          }
        }
        controls.dataset.printessControlsFor = root.id;
        uiMountTarget.insertAdjacentElement('afterend', controls);
      }

      const initialFormFields = parseJson(config.initialFormFields, []);
      const variantFieldMap = parseJson(config.variantFieldMap, {});

      Object.entries(variantFieldMap).forEach(([optionName, printessFieldName]) => {
        const option = form.elements.namedItem(optionName);
        if (!option || !option.value) return;
        if (!initialFormFields.some((field) => field.name === printessFieldName)) {
          initialFormFields.push({ name: printessFieldName, value: option.value });
        }
      });

      let printess;
      try {
        const module = await import(config.moduleUrl);
        printess = await module.createSlimUi({
          previewContainer,
          uiContainer,
          previewImage,
          loader,
          shopToken: config.shopToken,
          templateName: selectedTemplateName,
          published: config.published,
          lang: config.lang,
          textUpdateTimeout: 'short',
          sliderUpdateTimeout: 'short',
          priceCategoryLabels: config.showAddOnPrices === false ? {} : priceCategoryLabels,
          formFieldChangedCallback: handleAddOnFieldChange,
          progressStateChangedCallback: (show) => {
            printessProgressVisible = show;
            updatePreviewLoading();
            if (!show) scheduleSlimUiMaintenance();
          },
          formFields: initialFormFields
        });
        installCropDpiRefreshWorkaround(printess);
      } catch (error) {
        initialPreviewPending = false;
        printessProgressVisible = false;
        updatePreviewLoading();
        setError(formatError(error, config.messages.load));
        root.dataset.printessInitialized = 'error';
        return;
      }

      root.dataset.printessInitialized = 'ready';
      root.dataset.printessTemplateName = selectedTemplateName;
      root.dataset.printessSku = selectedSku;
      reviewButton.disabled = false;

      document.addEventListener('click', handleAddOnDocumentClick, true);
      const addOnPopupObserver = new MutationObserver(() => {
        decorateAddOnPopup();
      });
      addOnPopupObserver.observe(document.body, { childList: true, subtree: true });
      root.printessAddOnCleanup = () => {
        document.removeEventListener('click', handleAddOnDocumentClick, true);
        addOnPopupObserver.disconnect();
        document.querySelectorAll('#printess-bc-combo-list[data-printess-owned="true"]').forEach((popup) => {
          delete popup.dataset.printessOwned;
          popup.style.removeProperty('--printess-add-on-price-color');
          popup.querySelectorAll('.printess-slim-ui__addon-option-price').forEach((price) => price.remove());
        });
      };

      const uploadValidationObserver = new MutationObserver(scheduleSlimUiMaintenance);
      uploadValidationObserver.observe(uiContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
      scheduleSlimUiMaintenance();
      root.printessUploadValidationCleanup = () => uploadValidationObserver.disconnect();

      const variantTransitionStorageKey = `printess:variant-transition:${window.location.pathname}`;

      const restoreVariantScrollPosition = () => {
        let savedState = null;
        try {
          savedState = parseJson(window.sessionStorage.getItem(variantTransitionStorageKey), null);
          window.sessionStorage.removeItem(variantTransitionStorageKey);
        } catch (error) {
          savedState = null;
        }

        if (!savedState || typeof savedState.scrollY !== 'number' || Date.now() - savedState.savedAt > 15000) return;
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => window.scrollTo({ top: savedState.scrollY, behavior: 'auto' }));
        });
      };

      const showVariantTransition = (nextUrl) => {
        root.dataset.printessVariantTransition = 'true';
        form.setAttribute('aria-busy', 'true');

        try {
          window.sessionStorage.setItem(variantTransitionStorageKey, JSON.stringify({
            scrollY: window.scrollY,
            savedAt: Date.now()
          }));
        } catch {}

        if (!variantTransition) {
          window.location.replace(nextUrl);
          return;
        }

        variantTransition.hidden = false;
        document.documentElement.classList.add('printess-slim-ui__variant-transition-active');
        window.requestAnimationFrame(() => {
          variantTransition.classList.add('printess-slim-ui__variant-transition--visible');
        });
        window.setTimeout(() => window.location.replace(nextUrl), 180);
      };

      restoreVariantScrollPosition();

      let activeVariantId = String(selectedVariant.id || '');
      let activeTemplateName = selectedTemplateName;
      let variantSyncScheduled = false;

      const syncVariantTemplate = () => {
        variantSyncScheduled = false;
        if (root.dataset.printessVariantTransition === 'true') return;
        hideNativeAddButtons();
        const nextVariant = getSelectedVariant();
        const nextVariantId = String(nextVariant.id || '');
        if (!nextVariantId || nextVariantId === activeVariantId) return;

        const nextSku = typeof nextVariant.sku === 'string' ? nextVariant.sku.trim() : '';
        const nextTemplateName = saveTokenFromUrl || getTemplateName(nextVariant);

        if (!nextTemplateName) {
          const skuMessage = nextSku ? ` SKU: ${nextSku}` : '';
          setError(`${config.messages.skuTemplate || config.messages.configuration}${skuMessage}`);
          reviewButton.disabled = true;
          return;
        }

        activeVariantId = nextVariantId;
        root.dataset.printessSku = nextSku;

        if (nextTemplateName === activeTemplateName) {
          window.requestAnimationFrame(updateVisualProductPrice);
          return;
        }

        activeTemplateName = nextTemplateName;
        root.dataset.printessInitialized = 'loading';
        reviewButton.disabled = true;
        initialPreviewPending = true;
        printessProgressVisible = true;
        updatePreviewLoading();
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('variant', nextVariantId);
        showVariantTransition(nextUrl.toString());
      };

      const scheduleVariantTemplateSync = () => {
        if (variantSyncScheduled || root.dataset.printessVariantTransition === 'true') return;
        variantSyncScheduled = true;
        window.requestAnimationFrame(() => window.requestAnimationFrame(syncVariantTemplate));
      };

      const variantEventContainer = productFormContainer || form;

      variantEventContainer.addEventListener('change', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement) && !(target instanceof HTMLSelectElement)) return;
        const printessFieldName = variantFieldMap[target.name];
        if (printessFieldName) {
          const option = form.elements.namedItem(target.name);
          if (option && option.value) printess.setFormFieldValue(printessFieldName, option.value);
        }
        scheduleVariantTemplateSync();
      });

      variantEventContainer.addEventListener('click', scheduleVariantTemplateSync);

      form.addEventListener('submit', (event) => {
        forceQuantityOneAndHide();
        if (root.dataset.printessSubmitting === 'true') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        reviewButton.click();
      }, true);

      const setDialogLoading = (isLoading) => {
        dialog.classList.toggle('printess-slim-ui__dialog--loading', isLoading);
        dialog.toggleAttribute('aria-busy', isLoading);
        dialogLoading.hidden = !isLoading;
        if (isLoading) confirmation.hidden = true;
      };

      const preloadDialogImage = (source) => new Promise((resolve, reject) => {
        const pendingImage = new Image();
        pendingImage.addEventListener('load', () => {
          dialogImage.src = source;
          resolve();
        }, { once: true });
        pendingImage.addEventListener('error', () => {
          reject(new Error(config.messages.preview));
        }, { once: true });
        pendingImage.src = source;
      });

      const resetDialog = () => {
        confirmCheckbox.checked = false;
        if (legalConfirmCheckbox) legalConfirmCheckbox.checked = false;
        approveButton.disabled = true;
        confirmation.hidden = true;
        setDialogLoading(false);
        if (qualityWarning) {
          qualityWarning.hidden = true;
          delete qualityWarning.dataset.qualitySeverity;
        }
        if (qualityWarningText) qualityWarningText.textContent = '';
        dialog.classList.remove('printess-slim-ui__dialog--has-quality-warning');
      };

      reviewButton.addEventListener('click', async () => {
        if (reviewButton.disabled) return;
        setError('');
        reviewButton.disabled = true;
        reviewButton.setAttribute('aria-busy', 'true');

        try {
          currentSelectedAddOns = collectSelectedAddOns();
        } catch (error) {
          currentSelectedAddOns = [];
          reviewButton.disabled = false;
          reviewButton.removeAttribute('aria-busy');
          setError(formatError(error, config.messages.configuration));
          return;
        }

        resetDialog();
        currentSelectionProperties = collectCartSelectionProperties();
        const currentPreviewSource = getPreviewSource();
        if (currentPreviewSource) {
          dialogImage.src = currentPreviewSource;
        } else {
          dialogImage.removeAttribute('src');
        }
        setDialogLoading(true);
        if (!dialog.open) dialog.showModal();

        try {
          const data = await printess.createSaveToken();
          if (!data || !data.saveToken || !data.thumbnailUrl) throw new Error(config.messages.validation);
          clearResolvedImageValidationErrors();

          saveTokenFields.forEach((field) => { field.value = data.saveToken; });
          thumbnailFields.forEach((field) => { field.value = data.thumbnailUrl; });
          await preloadDialogImage(data.thumbnailUrl);
          syncDialogQualityWarning();
          setDialogLoading(false);
          confirmation.hidden = false;
        } catch (error) {
          if (dialog.open) dialog.close();
          await showValidationError(error);
        } finally {
          reviewButton.disabled = false;
          reviewButton.removeAttribute('aria-busy');
        }
      });

      const isOrderConfirmed = () => (
        confirmCheckbox.checked
        && (!legalConfirmCheckbox || legalConfirmCheckbox.checked)
      );

      const syncApproveAvailability = () => {
        approveButton.disabled = !isOrderConfirmed();
      };

      confirmCheckbox.addEventListener('change', syncApproveAvailability);
      if (legalConfirmCheckbox) {
        legalConfirmCheckbox.addEventListener('change', syncApproveAvailability);
      }

      editButton.addEventListener('click', () => {
        dialog.close();
      });

      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog || root.dataset.printessSubmitting === 'true') return;
        const bounds = dialog.getBoundingClientRect();
        const clickedOutsideDialog = event.clientX < bounds.left
          || event.clientX > bounds.right
          || event.clientY < bounds.top
          || event.clientY > bounds.bottom;
        if (clickedOutsideDialog && dialog.open) dialog.close();
      });

      dialog.addEventListener('close', resetDialog);

      approveButton.addEventListener('click', async () => {
        if (!isOrderConfirmed() || root.dataset.printessSubmitting === 'true') return;

        forceQuantityOneAndHide();
        root.dataset.printessSubmitting = 'true';
        approveButton.disabled = true;
        reviewButton.disabled = true;
        dialog.close();

        try {
          await addPersonalizedItemToCart();
        } catch (error) {
          root.dataset.printessSubmitting = 'false';
          reviewButton.disabled = false;
          setError(formatError(error, config.messages.submit));
        }

        window.setTimeout(() => {
          root.dataset.printessSubmitting = 'false';
          reviewButton.disabled = false;
        }, 3000);
      });
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll(rootSelector).forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(rootSelector).forEach((root) => {
        document.documentElement.classList.remove('printess-slim-ui__variant-transition-active');
        if (typeof root.printessMobilePreviewCleanup === 'function') {
          root.printessMobilePreviewCleanup();
        }
        if (typeof root.printessNativeGalleryCleanup === 'function') {
          root.printessNativeGalleryCleanup();
        }
        if (typeof root.printessCropDialogCleanup === 'function') {
          root.printessCropDialogCleanup();
        }
        if (typeof root.printessUploadValidationCleanup === 'function') {
          root.printessUploadValidationCleanup();
        }
        if (typeof root.printessAddOnCleanup === 'function') {
          root.printessAddOnCleanup();
        }
        if (typeof root.printessCombinedPriceCleanup === 'function') {
          root.printessCombinedPriceCleanup();
        }
        document.querySelectorAll('[data-printess-controls-for]').forEach((controls) => {
          if (controls.dataset.printessControlsFor === root.id) controls.remove();
        });
        document.querySelectorAll('[data-printess-lightbox-trigger-for]').forEach((trigger) => {
          if (trigger.dataset.printessLightboxTriggerFor === root.id) trigger.remove();
        });
        document.querySelectorAll('[data-printess-loader-for]').forEach((loader) => {
          if (loader.dataset.printessLoaderFor === root.id) loader.remove();
        });
        document.querySelectorAll('[data-printess-secondary-buy-hidden-for]').forEach((area) => {
          if (area.dataset.printessSecondaryBuyHiddenFor !== root.id) return;
          area.classList.remove('printess-slim-ui__secondary-buy-hidden');
          delete area.dataset.printessSecondaryBuyHiddenFor;
        });
        document.querySelectorAll('[data-printess-mount-visible-for]').forEach((area) => {
          if (area.dataset.printessMountVisibleFor !== root.id) return;
          area.classList.remove('printess-slim-ui__mount-visible');
          area.classList.remove('printess-slim-ui__option-heading-hidden');
          delete area.dataset.printessMountVisibleFor;
        });
        document.querySelectorAll('[data-printess-gallery-hidden-for]').forEach((area) => {
          if (area.dataset.printessGalleryHiddenFor !== root.id) return;
          area.classList.remove('printess-slim-ui__gallery-hidden-mobile');
          delete area.dataset.printessGalleryHiddenFor;
        });
        document.querySelectorAll('[data-printess-quantity-hidden-for]').forEach((area) => {
          if (area.dataset.printessQuantityHiddenFor !== root.id) return;
          area.classList.remove('printess-slim-ui__quantity-hidden');
          delete area.dataset.printessQuantityHiddenFor;
        });
        document.querySelectorAll('[data-printess-native-add-hidden-for]').forEach((button) => {
          if (button.dataset.printessNativeAddHiddenFor !== root.id) return;
          button.classList.remove('printess-slim-ui__native-add');
          button.hidden = button.dataset.printessOriginalHidden === 'true';
          if (button.dataset.printessHadAriaHidden === 'true') {
            button.setAttribute('aria-hidden', button.dataset.printessOriginalAriaHidden || '');
          } else {
            button.removeAttribute('aria-hidden');
          }

          const originalDisplay = button.dataset.printessOriginalDisplay || '';
          const originalDisplayPriority = button.dataset.printessOriginalDisplayPriority || '';
          if (originalDisplay) {
            button.style.setProperty('display', originalDisplay, originalDisplayPriority);
          } else {
            button.style.removeProperty('display');
          }

          delete button.dataset.printessNativeAddHiddenFor;
          delete button.dataset.printessOriginalHidden;
          delete button.dataset.printessHadAriaHidden;
          delete button.dataset.printessOriginalAriaHidden;
          delete button.dataset.printessOriginalDisplay;
          delete button.dataset.printessOriginalDisplayPriority;
        });
        document.querySelectorAll('[data-printess-external-preview-host-for]').forEach((area) => {
          if (area.dataset.printessExternalPreviewHostFor !== root.id) return;
          area.classList.remove('printess-slim-ui__external-preview-host');
          area.removeAttribute('aria-busy');
          delete area.dataset.printessExternalPreviewHostFor;
        });
        document.querySelectorAll('[data-printess-external-preview-image-for]').forEach((image) => {
          if (image.dataset.printessExternalPreviewImageFor !== root.id) return;
          image.classList.remove('printess-slim-ui__external-preview-image', 'printess-loader-visible');
          delete image.dataset.printessExternalPreviewImageFor;
        });
        document.querySelectorAll('[data-printess-native-gallery-for]').forEach((trigger) => {
          if (trigger.dataset.printessNativeGalleryFor !== root.id) return;
          const originalHref = trigger.dataset.printessOriginalGalleryHref;
          if (originalHref) {
            trigger.setAttribute('href', originalHref);
          } else {
            trigger.removeAttribute('href');
          }
          delete trigger.dataset.printessNativeGalleryFor;
          delete trigger.dataset.printessOriginalGalleryHref;
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
